import React from "react";
import { css, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
};

const Address: React.FC<Props> = ({
    children,
}) => {
    const theme = useTheme();

    const style = css`
        color: ${theme.colours.doveGray3};
    `;

    return (
        <p css={style}>{children}</p>
    );
};

export default Address;
